import { FilterOutlined } from '@ant-design/icons';
import { Button as BaseButton } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import { selectedToolbarButtonStyles } from '../../ToolbarStyles';

interface ButtonProps {
  $selected?: boolean;
}

const Button = styled(BaseButton)<ButtonProps>`
  align-items: center;
  font-size: 16px;
  padding: 2px 9px 0;

  ${(p) => p.$selected && selectedToolbarButtonStyles}
`;

function FiltersButton() {
  const store_creative = store.creative;

  const isDrawerOpen = store_creative?.displayPanel === PanelViews.FILTER;

  return (
    <Button
      $selected={isDrawerOpen}
      disabled={!store_creative}
      onClick={() => store_creative?.setPanel(PanelViews.FILTER)}
    >
      <FilterOutlined />
    </Button>
  );
}

export default observer(FiltersButton);
